export default "__VITE_ASSET__BT95Vn9k__"